import Cookies from "js-cookie";
import React, { useEffect, useMemo, useState } from "react";
import { IoIosMoon, IoMdSunny } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "semantic-ui-react";
import { setTheme } from "../../../redux/action/action";

const ColorSwitcher = ({ wordHidden }) => {
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  const dispatch = useDispatch();

  return (
    <div className="flex items-center justify-between gap-[5px]">
      <div className="flex items-center gap-[5px] text-dark-gray-text dark:text-base-input-dark-text">
        {wordHidden || <span>Color Theme</span>}
        {isDarkMode ? (
          <IoIosMoon className="text-xl" />
        ) : (
          <IoMdSunny className="text-xl" />
        )}
      </div>
      <Checkbox
        type="checkbox"
        checked={isDarkMode}
        onChange={(e, data) => {
          dispatch(setTheme(data.checked ? "dark" : "light"));
          Cookies.set("color-mode", data.checked ? "dark" : "light");
        }}
        toggle
      />
    </div>
  );
};

export default ColorSwitcher;
